import React from 'react';
import { 
  HelpCircle, 
  CreditCard, 
  BarChart, 
  Target, 
  FileText, 
  Zap, 
  TrendingUp, 
  ArrowRight 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по накоплениям на образование
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: BarChart,
      title: 'Начинайте как можно раньше',
      description: 'Чем раньше вы начнете накапливать, тем больший эффект даст сложный процент на инвестициях.'
    },
    {
      icon: Target,
      title: 'Целевой счет для образования',
      description: 'Откройте специальный счет или инвестиционный продукт для накоплений на образование.'
    },
    {
      icon: FileText,
      title: 'Налоговый вычет',
      description: 'Используйте социальный налоговый вычет за обучение (13% от расходов, до 15 600 руб. в год).'
    },
    {
      icon: CreditCard,
      title: 'Материнский капитал',
      description: 'Материнский капитал можно направить на образование любого из детей до 25 лет.'
    },
    {
      icon: TrendingUp,
      title: 'Регулярность важнее суммы',
      description: 'Даже небольшие, но регулярные взносы со временем превращаются в значительную сумму.'
    },
    {
      icon: Zap,
      title: 'Стипендиальные программы',
      description: 'Изучите возможности получения стипендий и грантов в выбранном учебном заведении.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Советы по накоплениям
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Расширенные стратегии
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Для эффективных накоплений рассмотрите инвестиционные инструменты: ИИС с налоговыми льготами, программы накопительного страхования жизни, ETF или ПИФы с невысокой комиссией.
            </p>
            <button className="w-full flex justify-center items-center py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Узнать подробнее
              <ArrowRight className="w-3 h-3 ml-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;